import { useCommentsSkeleton } from "@/features/collaboration/hooks";
import { cn } from "@/lib/cn";

const lineStyle =
  "tw-block tw-h-2 tw-w-1/2 tw-rounded-[100px] tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)] tw-animate-pulse-regular";

export const Skeleton = ({ id }: { id: string }) => {
  const hasThreads = useCommentsSkeleton({ id });
  if (!hasThreads) return <SkeletonNewThread />;
  return (
    <div className="tw-relative tw-min-h-24 tw-w-[400px] tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-shadow-comment-popover">
      <div className="tw-space-y-4 tw-p-4 tw-pt-3">
        <span className="tw-block tw-size-7 tw-animate-pulse-regular tw-rounded-full tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]" />
        <span className={cn(lineStyle, { "tw-w-[70%]": true })} />
        <span className={cn(lineStyle, { "tw-w-[70%]": true })} />
        <span className={lineStyle} />
      </div>
      <div className="tw-flex tw-h-14 tw-items-center tw-border-t tw-border-t-blue-50 tw-p-4">
        <span className={cn(lineStyle, { "tw-w-[40%]": true })} />
      </div>
    </div>
  );
};

const SkeletonNewThread = () => {
  return (
    <div className="tw-relative tw-min-h-24 tw-w-[400px] tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-p-4 tw-shadow-comment-popover">
      <div className="tw-flex tw-h-6 tw-items-center">
        <span className={lineStyle} />
      </div>
      <div className="tw-mt-3 tw-flex tw-items-center">
        <span className="tw-mr-1 tw-block tw-size-7 tw-rounded tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]" />
        <span className="tw-block tw-size-7 tw-rounded tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]" />
        <span className="tw-ml-auto tw-block tw-size-7 tw-rounded tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]" />
      </div>
    </div>
  );
};
